import { FORM_NAMES } from 'core/constants'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { IconClose } from 'components/Icons'
import {
  StyledModalContainer,
  Dimmed,
  StyledContent,
  StyledText,
  StyledTitle,
  StyledFormTitleBox,
  StyledFormContent,
  StyledForm,
  StyledGuideText,
  StyledFormSubmitButton,
  StyledFormCheckBoxContainer,
  StyledFormModalWrapper,
  StyledInput,
  StyledErrorMessage,
  StyledFormCheckBoxLabel,
  StyledAnchor,
  StyledTermButton,
  StyledFormCheckBoxLabelText,
} from './StyledModal'
import { useTranslation } from 'react-i18next'
import Icon from 'components/Icons/Icon'
import { ModalDataType } from 'core/store/global/types'
import { getUA } from 'core/singleton'
import TermModal from './TermModal'

export interface FormModalProps extends ModalDataType {}
export type IFormInput = {
  [FORM_NAMES.NAME]: string
  [FORM_NAMES.NUMBER]: number
  [FORM_NAMES.ACCEPT]: boolean
}

const FormModal: React.FC<FormModalProps> = (props) => {
  const {
    title,
    message,
    termsUrl,
    // cancelText = '닫기',
    // confirmText = '확인',
    onClose,
    onSubmit: _onSubmit,
  } = props
  const { t } = useTranslation()

  const onSubmit = async (inputValue: IFormInput) => {
    _onSubmit?.(inputValue)
    onClose?.()
  }
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<IFormInput>({ mode: 'onChange' })
  const values = watch()
  const { isWebview } = getUA()
  const [isShowTermModal, setIsShowTermModal] = useState(false)

  const isDisabled =
    Object.keys(errors).length !== 0 ||
    Object.keys(values).length === 0 ||
    !Object.values(values).every((value) => !!value)

  return (
    <>
      {isShowTermModal && (
        <TermModal termsUrl={termsUrl} onClose={() => setIsShowTermModal(false)} />
      )}
      <StyledModalContainer>
        <Dimmed onClick={onClose} />
        <StyledFormModalWrapper>
          <StyledContent title={title}>
            <StyledFormTitleBox>
              <StyledTitle>{title}</StyledTitle>
              <button onClick={onClose}>
                <IconClose />
              </button>
            </StyledFormTitleBox>
            <StyledText title={title}>{message}</StyledText>
            <StyledGuideText>{t('broadcast_notification_01')}</StyledGuideText>

            <StyledFormContent>
              <StyledForm id="modal-form-sf" onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <StyledInput
                    type="text"
                    placeholder={t('name')}
                    {...register(FORM_NAMES.NAME, { required: t('name_required') })}
                    error={Boolean(errors[FORM_NAMES.NAME]?.message)}
                  />
                  <StyledErrorMessage>{errors[FORM_NAMES.NAME]?.message}</StyledErrorMessage>
                </div>
                <div>
                  <StyledInput
                    type="text"
                    placeholder={t('contact_mobile_phone_number')}
                    {...register(FORM_NAMES.NUMBER, {
                      required: t('contact_number_required'),
                      pattern: {
                        value: /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/,
                        message: t('contact_number_invalid'),
                      },
                    })}
                    error={Boolean(errors[FORM_NAMES.NUMBER]?.message)}
                  />
                  <StyledErrorMessage>{errors[FORM_NAMES.NUMBER]?.message}</StyledErrorMessage>
                </div>
              </StyledForm>
              <StyledFormCheckBoxContainer>
                <StyledFormCheckBoxLabel>
                  <StyledInput
                    type="checkbox"
                    id="accept-sf"
                    {...register(FORM_NAMES.ACCEPT, {
                      required: '개인정보 수집 및 이용에 대해 필수로 동의하셔야 합니다.',
                    })}
                  />
                  <label htmlFor="accept-sf">
                    <Icon name="checkbox_off" />
                    <Icon name="checkbox_on" />
                  </label>
                  <StyledFormCheckBoxLabelText>
                    <strong>{t('agree_required_text')}</strong>
                    <span>{t('agree_information_text')}</span>
                  </StyledFormCheckBoxLabelText>
                </StyledFormCheckBoxLabel>
                {isWebview ? (
                  <StyledTermButton
                    onClick={() => {
                      setIsShowTermModal(true)
                    }}
                  >
                    {t('view_terms')}
                  </StyledTermButton>
                ) : (
                  <StyledAnchor href={termsUrl} target="_blank" rel="noreferrer">
                    {t('view_terms')}
                  </StyledAnchor>
                )}
              </StyledFormCheckBoxContainer>
              <StyledErrorMessage>{errors[FORM_NAMES.ACCEPT]?.message}</StyledErrorMessage>
            </StyledFormContent>
          </StyledContent>
          <StyledFormSubmitButton type="submit" form="modal-form-sf" disabled={isDisabled}>
            {t('alarm_receive')}
          </StyledFormSubmitButton>
        </StyledFormModalWrapper>
      </StyledModalContainer>
    </>
  )
}

export default FormModal
